export const EMPRESAS = ['CEDESCA', 'CNTEC'];
export const EMPRESA_POR_DEFECTO = 'CEDESCA';

// ui/Select pinta `option.value || ...`: un value '' acabaria siendo el texto de
// la opcion, asi que "Todas"/"Todos" usan un centinela que no viaja al backend.
export const SEDE_TODAS = 'todas';
export const TIPO_TODOS = 'todos';

export const TIPOS = [
  { value: TIPO_TODOS, label: 'Todos' },
  { value: 'actividad', label: 'Actividad' },
  { value: 'ciclo', label: 'Ciclo' },
];

export const CAMPOS_IMPORTE = [
  { key: 'importe_suelto', label: 'Importe suelto' },
  { key: 'importe_nuevo_suelto', label: 'Importe nuevo suelto' },
  { key: 'precio_ciclo', label: 'Precio ciclo' },
  { key: 'precio_ciclo_nuevo', label: 'Precio ciclo nuevo' },
];

// Mismos limites que el schema del backend (PUT /precios).
export const IMPORTE_MAX = 99999.999;
export const MAX_DECIMALES = 3;

export const DEBOUNCE_MS = 300;
export const PAGE_SIZE = 50;
